import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { receivedFiltersList } from "../actions/filters";
import { submitFilters, clearFilters } from "../actions/list";
import FiltersValueses from "./filtersValueses";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import menuArrow from "../images/menu-arrow.svg";
/**
 * Just a wrapper under list items
 *
 */
class Filters extends Component {
  static propTypes = {
    dataFilters: PropTypes.object,
    category: PropTypes.string,
    showLoader: PropTypes.bool,
    url: PropTypes.string,
    isChangeUrl: PropTypes.bool,
    filtersUrl: PropTypes.string,
    urlForChange: PropTypes.string,
    filterData: PropTypes.array,
    isRequest: PropTypes.bool,
    isSpecifyCategory: PropTypes.bool,
    location: PropTypes.string,
    filtersByGoodsForCount: PropTypes.object,
    filtersByGoods: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { filters: [], filtersValuesList: false };
  }

  /**
   * Components did mount
   *
   * @param nextProps
   */
  componentDidMount(nextProps) {
    console.log("this.props.category", this.props.category);
    if (this.props.category && this.props.isRequest) {
      this.props.getFiltersList(
        this.props.category,
        this.props.isSpecifyCategory !== undefined ? 1 : 0
      );
    }
    if (this.props.filtersUrl) {
      console.log("queryParams", this.props.filtersUrl);
      const filter = new URLSearchParams(this.props.filtersUrl).get("filter");
      if (filter) {
        const parsed = filter.split(" ");
        console.log("parsed", parsed);
        this.setState({ filters: parsed });
      }
    }
    //window.addEventListener("scroll", this.scrollStcikButton);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps !== undefined) {
      // console.log("prevProps >>>>> ", this.props.filtersUrl, prevProps);
    }

    if (this.props.filtersUrl !== prevProps.filtersUrl) {
      const filter = new URLSearchParams(this.props.filtersUrl).get("filter");
      if (filter) {
        const parsed = filter.split(" ");
        console.log("parsed", parsed);
        this.setState({ filters: parsed });
      } else {
        this.setState({ filters: [] });
      }
    }
  }

  componentWillUnmount() {
    //window.removeEventListener("scroll", this.scrollStcikButton);
  }

  scrollStcikButton = () => {
    let menuHeight = document.querySelectorAll(".filter-list--offcanvas");
    let el = document.querySelectorAll(".filters-controls");
    let elWidth = document.querySelector(".menu-default").offsetWidth - 30;
    let filtersHeight = document.querySelector(".menu-default");
    if (window.scrollY > 1) {
      for (let i = 0; i < el.length; i++) {
        el[i].classList.add("fix-controls");
        if (window.scrollY > menuHeight[i].offsetHeight - 950) {
          el[i].setAttribute("style", "position: relative ");
        } else if (window.scrollTop < 100) {
          el[i].setAttribute(
            "style",
            "position: fixed; width:" + elWidth + "px"
          );
        } else {
          el[i].setAttribute(
            "style",
            "position: fixed; width:" + elWidth + "px"
          );
        }
      }
    } else {
      let el = document.querySelectorAll(".filters-controls");
      for (let i = 0; i < el.length; i++) {
        el[i].classList.remove("fix-controls");
      }
    }
  };

  clearFilters = () => {
    
    return this.props.history.location.pathname;
  };
  changeSelect = (url) => {
    this.props.history.replace(url);
  };
  buildLink = (filterId, valueId)=>{
    if ( this.props.location ) {
      const filtersData = this.state.filters;
      const condition = `${filterId}-${valueId}`;
      const index = filtersData.indexOf(condition);
      if (index === -1) {
        this.setState({ filters: condition });

      } else {
        filtersData.splice(index, 1);
      }
      let search = this.props.location.search;
      let linkFilterQuery = '';
      if ( filtersData.length > 0 ){
        let linkFilterQuery = filtersData.join('+');
        if (this.props.location.search.includes('filter=')){
          search = this.props.location.
          search.
          replace(/(?<=filter=)(.*?)(?=&l|&p|&s|$)/gm,linkFilterQuery);
          search = search.replace(/page=[0-9]+/gm,"page=1");
          
        }else{
          search = this.props.location.search.length>0?`${search}&filter=${linkFilterQuery}`:`?filter=${linkFilterQuery}`;
        }
      }else{
        search = this.props.location.search.replace(/((&|\?)filter=)(.*?)(?=&l|&p|&s|$)/gm,'');
        search = search.replace(/((&|\&)page=)/gm, '?page=');
      }

      return `${this.props.location.pathname}${search}`.replace(/page=\d/,'page=1');
    }else{
      return '';
    }
  }

  // handleShowList = (item)=>{
  //   console.log('egrruuuuuuuuuuuuuuuuuuu', !this.state.filtersValuesList)
  //   this.setState({ showValeuList: item });
  // }

  /**
   * render
   *
   * @returns {*}
   */
  render() {
    const { t } = this.props;
    const selectFilters = this.state.filters;
  
   
    return (
      <>
        <div className="mob-header-offcanvas__title mob-header-offcanvas__title--filter  uk-position-relative">
          {t("Filters")}
          {this.state.filters.length > 0 && (
            <>
              <div className="filters-controls">
                <Link to={this.clearFilters()}>
                  <div className="filters-controls__btn-reset uk-text-center ">
                    {t("filters.clear")}{" "}
                    <span className="filters-controls__btn--icon">x</span>
                  </div>
                </Link>
              </div>
            </>
          )}
        </div>
        {Object.keys(selectFilters).length > 0 && (
          <>
            <div className="selected-filters">
              {selectFilters.map((i, v) => {
                const filterItem = i.split("-");
                if ( Object.keys(this.props.filtersByGoodsForCount).length > 0 && this.props.filtersByGoodsForCount[filterItem[0]]) {
                  return (
                    <div key={'filter'+i}  onClick={event => this.changeSelect(this.buildLink(filterItem[0],filterItem[1]))} className="filters-controls__btn-reset">
                      {this.props.filtersByGoodsForCount[filterItem[0]].name}{" : "}
                      <span className="uk-text-bold">{
                        this.props.filtersByGoodsForCount[filterItem[0]].values[
                          filterItem[1]
                        ].value
                      }</span>
                      <span className="filters-controls__btn--icon">x</span>
                    </div>
                  );
                }
              })}
            </div>
          </>
        )}
        <ul className="filter-list--offcanvas uk-list " uk-accordion="">
          {this.props.showLoader === false &&
            /*!this.props.isSpecifyCategory &&*/
            Object.keys(this.props.dataFilters).length > 0 &&
            Object.keys(this.props.dataFilters.dataFilters).map((itm, key) => (
              <li key={"filter" + itm} className={itm == 0 ? "uk-open" :''}>
                <div className="filter-list__border-bottom uk-accordion-title">
                  {this.props.dataFilters.dataFilters[itm].name}

                  {/* <img className={`filters-category-arrow ${itm >= 1?'filters-hidden-val':'filters-show-val'}`} src={menuArrow} alt={this.props.dataFilters.dataFilters[itm].name}/> */}
                </div>

                <FiltersValueses
                  location={this.props.location}
                  valuesData={this.props.dataFilters.dataFilters[itm]}
                  filterId={this.props.dataFilters.dataFilters[itm].filter_id}
                  filtersUrl={this.props.filtersUrl}
                  filterData={this.state.filters}
                  history={this.props.history}
                  filtersByGoods={this.props.filtersByGoods}
                  filtersByGoodsForCount={this.props.filtersByGoodsForCount}
                  showValeuList={this.state.filtersValuesList}
                />
              </li>
            ))}
          {/*<li key={"spec_filter_presense"} className={"uk-open"}>*/}
          {/*  <div className="filter-list__border-bottom uk-accordion-title">*/}
          {/*      {"Наявність"}*/}
          {/*  </div>*/}
          {/*  <FiltersValueses*/}
          {/*      location={this.props.location}*/}
          {/*      filterData={this.state.filters}*/}
          {/*      filterId={"existingFilter"}*/}
          {/*      filtersUrl={this.props.filtersUrl}*/}
          {/*      valuesData={{type:2, filter_id: "existingFilter", values:[*/}
          {/*          {value: "В наявності", id: 'g.countTotal>0'},*/}
          {/*          {value: "2-3 дні доставка", id: 'g.countTotalSupplier>0'},*/}
          {/*          {value: "Очікується поставка", id: 'g.countTotalSupplier===0'},*/}
          {/*        ]}}*/}
          {/*      filtersByGoods={this.props.filtersByGoods}*/}
          {/*      filtersByGoodsForCount={this.props.filtersByGoodsForCount}*/}
          {/*      showValeuList={this.state.filtersValuesList}*/}
          {/*  />*/}
          {/*</li>*/}
        </ul>
      </>
    );
  }
}
const filterList = withTranslation("translations")(Filters);
const mapStateToProps = (store) => {
  const {
    showLoader,
    filtersByGoods,
    filtersByGoodsForCount,
    dataFilters,
    isChangeUrl,
    urlForChange,
  } = store.goods;
  //console.log("filters by goods", filtersByGoods);
  return {
    dataFilters,
    filtersByGoods: filtersByGoods,
    filtersByGoodsForCount,
    showLoader: showLoader,
    isChangeUrl: isChangeUrl,
    urlForChange: urlForChange,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFiltersList: (category, isSpecificCategory) => {
      // dispatch(clearFilters());
      dispatch(receivedFiltersList(category, isSpecificCategory));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(filterList);
